import React from "react";
import LegalPageLayout, { Section } from "@/components/LegalPageLayout";
import { COMPANY } from "@/lib/company";

export default function TermsOfService() {
  return (
    <LegalPageLayout title="Terms of Service" updated={COMPANY.effectiveDate} testid="terms-page">
      <div className="mb-8 rounded-xl border border-border bg-muted/40 p-5" data-testid="terms-legal-entity">
        <p className="text-foreground">
          These Terms of Service govern your use of the {COMPANY.brand} website and services. {COMPANY.brand} is a
          registered "doing business as" (DBA) name owned and operated by <strong>{COMPANY.legalName}</strong>. By
          using this site, you agree to these Terms with {COMPANY.legalName}, doing business as {COMPANY.brand}.
        </p>
      </div>

      <Section heading="1. The Business Behind This Site">
        <p>
          This website and its services are provided by {COMPANY.legalName}, a limited liability company, operating
          under the DBA {COMPANY.brand}. All references to "{COMPANY.brand}," "we," "us," or "our" refer to{" "}
          {COMPANY.legalName}.
        </p>
      </Section>

      <Section heading="2. Accounts">
        <p>
          You are responsible for maintaining the confidentiality of your account credentials and for all activity
          under your account. You agree to provide accurate, current information and to keep it updated.
        </p>
      </Section>

      <Section heading="3. Winterizing Services & Pricing">
        <p>
          Winterizing services are provided subject to our Winterizing Policy, which is presented during signup.
          Pricing shown at the time of signup applies to that season. Add-on services must be selected and
          acknowledged at signup to be covered.
        </p>
      </Section>

      <Section heading="4. Communications Consent">
        <p>
          By creating an account or signing up, you consent to receive service-related emails and, where you opt in,
          SMS text messages from {COMPANY.legalName} (DBA {COMPANY.brand}). Message and data rates may apply. Reply
          STOP to opt out of SMS at any time.
        </p>
      </Section>

      <Section heading="5. Limitation of Liability">
        <p>
          To the fullest extent permitted by law, {COMPANY.legalName} is not liable for indirect, incidental, or
          consequential damages arising from your use of the site or services. Service guarantees are governed by the
          Winterizing Policy.
        </p>
      </Section>

      <Section heading="6. Changes to These Terms">
        <p>
          We may update these Terms from time to time. Continued use of the site after changes take effect constitutes
          acceptance of the updated Terms.
        </p>
      </Section>

      <Section heading="7. Contact">
        <p>
          {COMPANY.legalName} (DBA {COMPANY.brand})
          <br />
          Email: <a href={`mailto:${COMPANY.contactEmail}`} className="text-secondary underline">{COMPANY.contactEmail}</a>
          <br />
          Website: {COMPANY.website}
        </p>
      </Section>
    </LegalPageLayout>
  );
}
